import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import About from '@/pages/home/components/About';
import Differentials from '@/pages/home/components/Differentials';
import Testimonials from '@/pages/home/components/Testimonials';
import FAQ from '@/pages/home/components/FAQ';
import Location from '@/pages/home/components/Location';
import Contact from '@/pages/home/components/Contact';
import Footer from '@/pages/home/components/Footer';
import WhatsAppButton from '@/pages/home/components/WhatsAppButton';

const HomePage = () => {
  return (
    <main>
      <Navbar />
      <Hero />
      <About />
      <Differentials />
      <Testimonials />
      <FAQ />
      <Location />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default HomePage;
